import * as actionTypes from './actionTypes';
import { BrandVehicleModel } from '@app/src/views/StepOne/form/models/brandVehicle';

interface State {
  data: BrandVehicleModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const brandVehicleTop = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_BRAND_VEHICLE_TOP_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_BRAND_VEHICLE_TOP_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_BRAND_VEHICLE_TOP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
